// extracted by mini-css-extract-plugin
export default {"container":"ADLink_container__gjF7b","modal":"ADLink_modal__fg85T","content":"ADLink_content__dmrZ-","detailBtn":"ADLink_detailBtn__YHWcy","closeBtn":"ADLink_closeBtn__wnCeD"};